export const SHAPESHIFT_COSMOS_VALIDATOR_ADDRESS =
  'cosmosvaloper199mlc7fr6ll5t54w7tts7f4s0cvnqgc59nmuxf'
export const SHAPESHIFT_OSMOSIS_VALIDATOR_ADDRESS =
  'osmovaloper1xf9zpq5kpxks49cg606tzd8qstaykxgt2vs0d5'
